
<template>
  <div class="browse-section">
    <q-img class="image" src="images/browse_title.jpg" contain />
    <div>
      <div class="section-title">Image browser</div>
      <div class="section-paragraph">
        Images are loaded directly onto your device after shooting.
        If required, you can immediately share the images with other apps and, for example, edit them directly with your favorite editing app.
      </div>
      <div class="section-paragraph features">
        <icon-box src="/images/browse_index.svg">Browse images*</icon-box>
        <icon-box src="/images/browse_transfer.svg">Transfer Raw / Jpg*</icon-box>
        <icon-box src="/images/browse_info.svg">Show Exif metadata</icon-box>
      </div>
      <div class="section-footnote">*Availability depends on the connected camera.</div>
    </div>
  </div>
</template>

<script>
import IconBox from "@/components/IconBox.vue";

export default {
  components: {
    IconBox
  }
};
</script>

<style scoped>
.browse-section {
  display: grid;
  grid-template-columns: 2fr 3fr;
  align-items: center;
  justify-items: center;
  grid-gap: var(--content-margin);
  padding: var(--section-padding);
}

.features {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--content-margin);
}

.image {
  max-height: 300pt;
}
</style>
